import { FC } from 'react'

import { Cluster, Grid, Skeleton, Stack, Table, TableFooter, TableHead, TableRow } from '@forto-dev/phoenix-ui-core'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Back } from '@/fragments/back'
import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { WidgetSkeleton } from '@/fragments/widgetSkeleton'
import { useLocalisation } from '@/utils/localisation'

import { ShipmentDetailTitleSkeleton } from '../details/detailsSkeleton'

const ShipmentDemDetMainSkeleton: FC = () => {
  const { translate } = useLocalisation()
  return (
    <Stack gap={24}>
      <Skeleton variant="content" size={16} fullWidth />
      {Array.from({ length: 2 }).map((_, index) => (
        <Stack key={index} gap={16}>
          <Grid col={6}>
            <Skeleton variant="badge" size={12} fullWidth />
          </Grid>
          <Table
            columns={[
              {
                id: 'id',
                header: translate('details.dem-det.table.id'),
                cell: () => <Skeleton variant="content" />,
                accessorKey: '',
              },
              {
                id: 'charges',
                header: translate('details.dem-det.table.charges'),
                cell: () => <Skeleton variant="content" />,
                accessorKey: '',
              },
              {
                id: 'type',
                header: translate('details.dem-det.table.type'),
                cell: () => <Skeleton variant="content" />,
                accessorKey: '',
              },
              {
                id: 'dischargeDate',
                header: translate('details.dem-det.table.discharge'),
                cell: () => <Skeleton variant="content" />,
                accessorKey: '',
              },
              {
                id: 'gateOutDate',
                header: translate('details.dem-det.table.gate'),
                cell: () => <Skeleton variant="content" />,
                accessorKey: '',
              },
              {
                id: 'emptyReturnDate',
                header: translate('details.dem-det.table.emptyReturnDate'),
                cell: () => <Skeleton variant="content" />,
                accessorKey: '',
              },
              {
                id: 'period',
                header: translate('details.dem-det.table.period'),
                cell: () => <Skeleton variant="content" />,
                accessorKey: '',
              },
              {
                id: 'actions',
                header: '',
                cell: () => <Skeleton variant="button" />,
                accessorKey: '',
              },
            ]}
            data={[{}]}
            footless
            customFooter={
              <TableFooter>
                <TableRow>
                  <TableHead colSpan={8}>
                    <Stack gap={16}>
                      <Grid col={6}>
                        <Cluster />
                        <Skeleton variant="badge" fullWidth />
                        <Cluster />
                      </Grid>
                    </Stack>
                  </TableHead>
                </TableRow>
              </TableFooter>
            }
          />
        </Stack>
      ))}
    </Stack>
  )
}

export const DemDetSkeleton: FC = () => {
  return (
    <Layout
      header={<Header />}
      title={<ShipmentDetailTitleSkeleton />}
      hideTitleBackgroundImage
      sidebar={<WidgetSkeleton count={4} />}
      navigation={<Back to="/" />}
      main={<ShipmentDemDetMainSkeleton />}
      footer={<Footer />}
    />
  )
}
